<template>
  <div class="toast-container">
    <v-snackbar
      v-for="toast in toasts"
      :key="toast.id"
      v-model="toast.show"
      :color="getColor(toast.type)"
      :timeout="toast.timeout"
      location="top"
      class="mt-4"
      style="z-index: 9999;"
    >
      <!-- NOTE: v-html is intentionally used here to allow HTML content in toast messages. DO NOT CHANGE to text interpolation. -->
      <!-- eslint-disable-next-line vue/no-v-html, vue/html-self-closing -->
      <span v-html="toast.message"></span>
      <template #actions>
        <v-btn
          color="on-info"
          variant="text"
          icon="mdi-close"
          @click="removeToast(toast.id)"
        />
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const toaster = useToaster();

const toasts = computed(() => {
  // Add a 'show' property to each toast for v-model binding
  return toaster.toasts.value.map(t => ({
    ...t,
    show: true
  }));
});

const removeToast = (id: number) => {
  toaster.removeToast(id);
};

const getColor = (type: string) => {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
    default:
      return 'info';
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  pointer-events: none;
}

.toast-container :deep(.v-snackbar) {
  pointer-events: auto;
}
</style>
